import { Routes, Route, Navigate } from 'react-router-dom'
import Layout from './components/Layout'
import LoginPage from './pages/LoginPage'
import RegisterPage from './pages/RegisterPage'
import LandingPage from './pages/LandingPage'
import GyartmanylapPage from './pages/seo/GyartmanylapPage'
import SzarmazasiIgazolasPage from './pages/seo/SzarmazasiIgazolasPage'
import HaccpIgazolasPage from './pages/seo/HaccpIgazolasPage'
import KaloriaSzamitasPage from './pages/seo/KaloriaSzamitasPage'
import AllergenCimkePage from './pages/seo/AllergenCimkePage'
import KaracsonyiVasarPage from './pages/seo/KaracsonyiVasarPage'
import RolunkPage from './pages/RolunkPage'
import KapcsolatPage from './pages/KapcsolatPage'
import CukraszdaNyitasBlogPage from './pages/blog/CukraszdaNyitasBlogPage'
import MitJelentAHaccpIgazolasPage from './pages/blog/MitJelentAHaccpIgazolasPage'
import NyomonkovetesQrKoddalPage from './pages/blog/NyomonkovetesQrKoddalPage'
import TraceabilityPage from './pages/TraceabilityPage'
import TraceabilityPublicPage from './pages/TraceabilityPublicPage'
import DashboardPage from './pages/DashboardPage'
import RecipesPage from './pages/RecipesPage'
import RecipeDetailPage from './pages/RecipeDetailPage'
import IngredientsPage from './pages/IngredientsPage'
import HaccpPage from './pages/HaccpPage'
import SettingsPage from './pages/SettingsPage'
import AszfPage from './pages/AszfPage'
import ElofizetsPage from './pages/ElofizetsPage'
import AdminPage from './pages/AdminPage'
import ForgotPasswordPage from './pages/ForgotPasswordPage'
import ResetPasswordPage from './pages/ResetPasswordPage'

function RequireAuth({ children }: { children: React.ReactNode }) {
  const token = localStorage.getItem('token')
  if (!token) return <Navigate to="/login" replace />
  return <>{children}</>
}

function RootRedirect() {
  const token = localStorage.getItem('token')
  return token ? <Navigate to="/receptek" replace /> : <LandingPage />
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<RootRedirect />} />
      <Route path="/gyartmanylap" element={<GyartmanylapPage />} />
      <Route path="/szarmazasi-igazolas" element={<SzarmazasiIgazolasPage />} />
      <Route path="/haccp-igazolas" element={<HaccpIgazolasPage />} />
      <Route path="/receptbol-kaloria-szamitas" element={<KaloriaSzamitasPage />} />
      <Route path="/allergen-cimke-nyomtatas" element={<AllergenCimkePage />} />
      <Route path="/karacsonyi-vasar-elelmiszer-arusitas" element={<KaracsonyiVasarPage />} />
      <Route path="/rolunk" element={<RolunkPage />} />
      <Route path="/kapcsolat" element={<KapcsolatPage />} />
      <Route path="/blog/cukraszda-nyitas-dokumentacio" element={<CukraszdaNyitasBlogPage />} />
      <Route path="/blog/mit-jelent-a-haccp-igazolas" element={<MitJelentAHaccpIgazolasPage />} />
      <Route path="/blog/alapanyag-nyomonkoveres-qr-koddal" element={<NyomonkovetesQrKoddalPage />} />
      <Route path="/nyomonkovetes/:token" element={<TraceabilityPublicPage />} />
      {/* rövid QR-cím a tekercses címkén: HTTPS://CUKRASZDOC.HU/N/<10 karakter> (a route kisbetű-független) */}
      <Route path="/n/:token" element={<TraceabilityPublicPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/aszf" element={<AszfPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route element={<RequireAuth><Layout /></RequireAuth>}>
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/receptek" element={<RecipesPage />} />
        <Route path="/receptek/:id" element={<RecipeDetailPage />} />
        <Route path="/alapanyagok" element={<IngredientsPage />} />
        <Route path="/haccp" element={<HaccpPage />} />
        <Route path="/nyomonkovetes" element={<TraceabilityPage />} />
        <Route path="/beallitasok" element={<SettingsPage />} />
        <Route path="/elofizetes" element={<ElofizetsPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Route>
    </Routes>
  )
}
